export default {
  title: {
    id: 'bo_sellers_customer_care_open_tasks_technical_issue_block_surtitle',
    defaultMessage: 'Something went wrong in our end.',
  },
  description: {
    id: 'bo_seller.customer_care.technical_issue_block_description',
    defaultMessage: 'Sit tight while we fix the issue, and try again.',
  },
  buttonLabel: {
    id: 'bo_seller.customer_care.technical_issue_block_refresh_button_label',
    defaultMessage: 'Refresh the page',
  },
}
